<template>
<section>
    <div class="wrap">
        <div class="title_box" style="margin: 20px 0 10px;">
            <p></p>
            <select class="nojs_select" v-model="type">
                <option value="">전체</option>
                <option v-for="(type) in Object.values(FAQ_TYPE_CUSTOMER)" :key="`faq-type-customer-list-item-${type.id}`"
                    :value="type.id"
                >
                    {{type.title}}
                </option>
            </select>
        </div>

        <form action="" class="onenone_input">
            <input type="text" v-model="title" placeholder="제목을 작성해 주세요">
            <textarea name="text" v-model="content" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"' placeholder="내용을 작성해 주세요.(20자 이상)"></textarea>
        </form>
    </div>
    <button class="default_fixed_btn" @click="validate">문의전송</button>
</section>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name:'QnaCreate',
    data() {
        return {
            type: '',
            title: '',
            content: '',
        }
    },
    computed: {
        ...mapState({
            auth: state => state.auth.item,
            FAQ_TYPE_CUSTOMER: state => state.codeDictionary.items.FAQ_TYPE_CUSTOMER,
            QNA_DTYPE_CUSTOMER_ID: state => state.codeDictionary.items.QNA_DTYPE.CUSTOMER.id,
        }),
    },
    created () {
        this.$store.commit('SHOW_ONLOAD');
    },
    methods: {
        validate() {
            try {
                if(!this.type) throw '분류를 선택해 주세요.';
                if(!this.title) throw '제목은 필수 입력 사항입니다.';
                if(!this.content) throw '내용은 필수 입력 사항입니다.';
                if(this.content.length < 20) throw '내용은 20자 이상 쓰셔야 합니다.';
            }
            catch (errorMsg) {
                this.$store.commit('OPEN_MODAL', {
                    title: '알림', 
                    content: errorMsg, 
                    btnOne: '확인', 
                });
                return false;
            }

            this.submit();
        },
        submit() {
            this.$store.dispatch('CREATE_QNA',{
                dtype: this.QNA_DTYPE_CUSTOMER_ID,
                type: this.type,
                userId: this.auth.id,
                title: this.title,
                content: this.content,
            })
            .then(()=>{
                this.$store.commit('OPEN_MODAL', { 
                    content: '1:1 등록이 완료되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => { this.$router.push('/qna') }
                });
            });
        }
    },
}
</script>

<style>
    #app {
        background:#fff
    }
</style>